import './bootstrap.js'
import './assets/sass-portal/app.scss'
import { createApp } from "vue";

// Styles
// Toast Styling
import "vue-toast-notification/dist/theme-sugar.css";
import "vuejs-dialog/dist/vuejs-dialog.min.css";

/***
 * Font Awesome
 **/
import { library } from '@fortawesome/fontawesome-svg-core'

import {
    faLocationPin,
    faCircleCheck,
    faCircleXmark,
    faChevronUp,
    faChevronRight,
    faChevronLeft,
    faChevronDown,
    faFilter,
    faUndo,
    faSearch,
    faTimes,
    faPlus,
    faMinus,
    faQuestion,
    faCircle,
    faHouse,
    faUser,
    faBriefcase,
    faEnvelope,
    faPhone,
    faClock,
    faBarcode,
    faCheck as freeFaCheck,
    faExclamation as freeFaExclamation,
    faStar,
    faPercent,
    faDownload,
    faBell,
    faPencil as freeFaPencil,
    faCalendar,
    faTruck,
    faShoppingBasket,
    faSpinner,
    faWalking,
    faFilePdf,
    faArrowRightLong,
    faLink,
} from '@fortawesome/free-solid-svg-icons'

import {
    faThumbsUp,
    faThumbsDown,
    faFlag,
} from '@fortawesome/free-regular-svg-icons'

import {
    faLinkedinIn,
    faFacebookF,
    faInstagram,
    faVimeoV,
    faWhatsapp
} from '@fortawesome/free-brands-svg-icons'

import {
    faCircleEllipsis,
    faGift,
    faEye,
    faEyeSlash,
    faEgg,
    faSleigh
} from '@fortawesome/pro-solid-svg-icons'

import {
    faBookOpen,
    faQuestion as faRegularQuestion
} from '@fortawesome/pro-regular-svg-icons'

import {
    faCheck,
    faPencil,
    faPuzzle,
    faCircleInfo,
    faTriangleExclamation,
    faArrowRightArrowLeft,
    faCircleExclamation,
    faFileChartPie,
    faGear,
    faEnvelope as faProLightEnvelope,
    faBoxArchive,
    faTrashCan,
    faPersonWalking,
    faCircleChevronLeft,
    faCircleChevronRight,
} from '@fortawesome/pro-light-svg-icons'

// import {} from '@fortawesome/pro-thin-svg-icons'
// import {} from '@fortawesome/pro-duotone-svg-icons'
// import {} from '@fortawesome/sharp-solid-svg-icons'
import { faSensorTriangleExclamation } from '@fortawesome/sharp-regular-svg-icons'
// import {} from '@fortawesome/sharp-light-svg-icons'

// Icons
[
    faPersonWalking,
    faCheck,
    faGift,
    faSleigh,
    faEgg,
    faCircleCheck,
    faCircleXmark,
    faPencil,
    faCalendar,
    faTruck,
    faSpinner,
    faShoppingBasket,
    faThumbsUp,
    faThumbsDown,
    faCircleInfo,
    faBookOpen,
    faFlag,
    faPuzzle,
    faTriangleExclamation,
    faCircleInfo,
    faLocationPin,
    faBell,
    faEye,
    faEyeSlash,
    faChevronUp,
    faChevronRight,
    faChevronLeft,
    faChevronDown,
    faCircleChevronLeft,
    faCircleChevronRight,
    faCircleEllipsis,
    faCircleExclamation,
    faFilter,
    faGear,
    faProLightEnvelope,
    faBoxArchive,
    faStar,
    freeFaPencil,
    faPercent,
    faDownload,
    faUndo,
    faBarcode,
    faHouse,
    faSearch,
    faTimes,
    faArrowRightArrowLeft,
    faPlus,
    faMinus,
    faQuestion,
    faRegularQuestion,
    faLinkedinIn,
    faFacebookF,
    faInstagram,
    faVimeoV,
    faFileChartPie,
    faWhatsapp,
    faCircle,
    faUser,
    faBriefcase,
    faEnvelope,
    faPhone,
    faClock,
    freeFaCheck,
    freeFaExclamation,
    faTrashCan,
    faWalking,
    faFilePdf,
    faArrowRightLong,
    faLink
].forEach(icon => {
    library.add(icon)
})


// import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import FAIcon from './components/core/Icons/FAIcon.vue' // Using a wrapper for the icon because it doesn't support conditional icons by default
import PasswordStrength from './components/auth/PasswordStrength.vue'
import Banner from './components/core/Layout/Banner/Banner.vue'

import System from './Modules/System.js'
window.System = System
    .setSystem(window.systemData)

const app = createApp()
    .mixin({
        data: () => ({
            System: System
                .setSystem(window.systemData)
        })
    })
    .mixin({
        // This is a global mixin, it is applied to every vue instance
        // TODO - Could we move this into a global vuex module?
        data: function () {
            return {
                openAvatarUserMenu: false, // The User menu when clicking on the user's initials to bring up the mini nav.
                showMobMenu: false,
                showMobMenuDropdown: false,

                // START Menu states
                // New Nav rebuild
                openMenuShop: false, // Main Shop Mega Menu
                openMenuUserProfile: false, // User Profile Menu / Avatar Menu
                openMobileBurgerMenu: false, // Mobile Burger Menu
                openMobileShopMenu: false, // Mobile Shop Menu (accordion)
                // END   Menu states
            }
        },
        methods: {
            hideMenuShop() {
                //console.log("Hide Shop Menu");
                this.openMenuShop = false;
            },
            hideMenuUserProfile() {
                //console.log("Hide User Profile Menu");
                this.openMenuUserProfile = false;
            },
        }
    })
    //Auth
    .component("PasswordStrength", PasswordStrength)

    // Navigation Items
    // .component("desktop-navigation-tab-button", DesktopNavigationTabButton)
    // .component("profile-dropdown-button", ProfileDropdownButton)
    // .component("navigation-icon-badge", NavigationIconBadge)

    // .component("associated-products", AssociatedProducts)

    // .component("footer-component", Footer)

    // // Card Management
    // .component("card-management", CardManagement)

    // // Header and Nav
    // .component("shopping-basket-icon", ShoppingBasketIcon)
    // .component("product-search", ProductSearch)
    // .component("page-title", PageTitle)

    // // Power BI / MI Report
    // .component("best-viewed-on-desktop", BestViewedOnDesktop)

    // // Consumables (Products & Variants)
    // .component("product-variant", ProductVariant)
    // .component("product-quantity", ProductQuantity)
    // .component("product-rating", ProductRating)
    // .component("product-variant-slimline", ProductVariantSlimline)
    // .component("product-output-view-basket", ProductOutputViewBasket)
    // .component("similar-product-list", SimilarProductList)

    // // Favorites
    // .component("favourites-list", FavouritesList)

    // // Orders
    // .component("order-items-pill", OrderItemsPill)
    // .component("order-details", OrderDetails)

    // //Banner
    .component("banner", Banner)

    // // Basket
    // .component("shopping-basket-list", ShoppingBasketList)
    // .component("suggestions-list", SuggestionsList)
    // .component('basket-notifications', BasketNotifications)


    // // Card ( Credit and Debit)

    // .component("add-new-card", AddNewCard)
    // .component("saved-cards", SavedCards)
    // .component("edit-card", EditCard)
    // .component("billing-address", BillingAddress)

    // // Account Switcher
    // .component("account-switcher", AccountSwitcher)

    // // Settings
    // .component("contact-card", ContactCard)
    // .component("address-card", AddressCard)
    // .component("credit-card", CreditCard)
    // .component("contacts-table", ContactsTable)

    // // UX - User Feedback
    // .component("user-feedback", UserFeedback)
    // .component('info-area', InfoArea)

    // // Marketing
    // .component("marketing-options", MarketingOptions)

    // // Survey
    // .component("survey-nps", SurveyNps)
    // .component("survey-scale", SurveyScale)
    .component('fa-icon', FAIcon)
    .mount('#app');
